import { SETTINGS_ACTIONS } from './settingsActionMap';
import { createScopedDispatchers } from 'shared/helpers/shared/selectHandlers/createScopedDispatchers';

const { selectMachineDispatch } = createScopedDispatchers(SETTINGS_ACTIONS, 'switch');

export const selectMachineIndicatorDispatcherHandler = (
  dispatch,
  name,
  locationIdx,
  specLocationIdx,
  machineIdx,
  newSelectedMachine,
  select = true
) =>
  selectMachineDispatch(
    dispatch,
    name,
    undefined,
    locationIdx,
    specLocationIdx,
    machineIdx,
    newSelectedMachine,
    select
  );
